exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-vielen-dank-jsx": () => import("./../../../src/pages/vielen-dank.jsx" /* webpackChunkName: "component---src-pages-vielen-dank-jsx" */),
  "component---src-templates-pages-jsx": () => import("./../../../src/templates/pages.jsx" /* webpackChunkName: "component---src-templates-pages-jsx" */),
  "component---src-templates-referenzen-jsx": () => import("./../../../src/templates/referenzen.jsx" /* webpackChunkName: "component---src-templates-referenzen-jsx" */)
}

